import { DbtCloudConnectionResponse } from "../../types";

// Get last sync timestamp from most recent environment
export const getLastSyncInfo = (
  connection: DbtCloudConnectionResponse
): { lastSyncAt: string | null; lastSyncStatus: string | null } => {
  let lastSyncAt: string | null = null;
  let lastSyncStatus: string | null = null;

  connection.projects?.forEach(project => {
    project.environments?.forEach(env => {
      if (env.last_processed_run_finished_at) {
        if (!lastSyncAt || new Date(env.last_processed_run_finished_at) > new Date(lastSyncAt)) {
          lastSyncAt = env.last_processed_run_finished_at;
        }
      }
    });
  });

  // Get status from schedule if available
  if (connection.schedule?.last_sync_status) {
    lastSyncStatus = connection.schedule.last_sync_status;
  }

  return { lastSyncAt, lastSyncStatus };
};

// Get count of enabled environments
export const getEnabledEnvironmentCount = (connection: DbtCloudConnectionResponse): number => {
  let count = 0;
  connection.projects?.forEach(project => {
    if (project.is_enabled) {
      project.environments?.forEach(env => {
        if (env.is_enabled) count++;
      });
    }
  });
  return count;
};
